var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.801,
    height: 23.989,
    viewBox: "0 0 21.801 23.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#434343;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M840.59,310.064a102.811,102.811,0,0,0,5.175,13.941c.039.085.148.034.126-.061a15.492,15.492,0,0,1,.422-9.017,11.548,11.548,0,0,1,1.255-2.375.708.708,0,0,0,.055-.675,18.064,18.064,0,0,0-8.769-8.512.221.221,0,0,0-.292.132c-.63,1.407-3.984,9.455-1.454,15.993a11.975,11.975,0,0,0,8.047,7.55c.1.029.175-.1.12-.207C840.012,317.21,840.59,310.064,840.59,310.064Z",
    transform: "translate(-836.177 -303.346)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M858.83,308.758c-1.308.338-7.316,2.161-9.437,7.642-1.808,4.67-.189,9.5.508,11.209a.107.107,0,0,0,.209-.022,41.388,41.388,0,0,1,6.663-14.847,85.724,85.724,0,0,0-5,15.332c-.024.1.042.2.128.18,1.51-.367,4.784-1.952,6.847-6.257,2.476-5.167.842-11.573.424-13.006A.293.293,0,0,0,858.83,308.758Z",
    transform: "translate(-838.288 -304.267)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/vegan.b8c71359b620d1d403645f6a831e46a1.svg";
export { ForwardRef as ReactComponent };